// extracted by mini-css-extract-plugin
export default {"materialUIBox":"CountrySelector_materialUIBox__KnOQ8"};